<template>
  <div>
    <div class="search">
      <div class="w search-box">
        <router-link
          to="/"
          @click.native="refresh"
          :title="common_info.store.name"
          ><img
            class="img-default search-img"
            :src="common_info.store.logo"
            :alt="common_info.store.name"
        /></router-link>
        <div class="search-c">
          <div class="search-item">
            <div class="box">
              <img
                class="img-default img"
                src="../../assets/images/search.png"
                alt
              />
              <input
                placeholder="搜索商品"
                class="search-input"
                type="text"
                v-model="searchtext"
                ref="searchtext"
              />
            </div>
            <div class="search-btn" @click="searchshop()">搜索</div>
          </div>
          <ul class="search-default" v-if="common_info.store.search_hot_open">
            <li
              v-for="(item, index) in common_info.store.search_hot_content"
              :key="index"
            >
              <span @click="seachlist(item)" v-text="item"></span>
            </li>
          </ul>
        </div>
        <!-- <div class="cat" @click="cartgoto()">
					<img class="img-default xia" src="../../assets/images/cat.svg" alt /> 我的购物车
					<span v-text="carnum"></span>
				</div> -->
        <!-- <div class="cat" >
					<a href="https://old.xzcare.com/" target="_blank">旧系统入口</a>
				</div> -->
        <div class="code_wrap">
          <ul class="code">
            <li class="code-item code-item1">
              <div class="code-img">
                <img src="../../assets/images/app_store.png" alt="" />
              </div>
              <div
                class="code-name smallsize-font"
                :class="isChrome ? 'chrome' : ''"
              >
                APP商城
              </div>
              <img
                class="code-activity"
                src="../../assets/images/new_register.png"
                alt=""
              />
              <div class="big-code1">
                <img class="bg" src="../../assets/images/bg.png" alt="" />
                <img
                  class="code"
                  src="../../assets/images/app_store.png"
                  alt=""
                />
              </div>
            </li>
            <li class="code-item code-item2">
              <div class="code-img">
                <img src="../../assets/images/mini_store.jpg" alt="" />
              </div>
              <div
                class="code-name smallsize-font"
                :class="isChrome ? 'chrome' : ''"
              >
                小程序商城
              </div>
              <img
                class="code-activity"
                src="../../assets/images/new_register.png"
                alt=""
              />
              <div class="big-code2">
                <img class="bg" src="../../assets/images/bg.png" alt="" />
                <img
                  class="code"
                  src="../../assets/images/mini_store.jpg"
                  alt=""
                />
              </div>
            </li>
            <li class="code-item code-item3">
              <div class="code-img">
                <img src="../../assets/images/xz_public.png" alt="" />
              </div>
              <div
                class="code-name smallsize-font"
                :class="isChrome ? 'chrome' : ''"
              >
                修正健康公众号
              </div>
              <img
                class="code-activity3"
                src="../../assets/images/more_activity.png"
                alt=""
              />
              <div class="big-code3">
                <img class="bg" src="../../assets/images/bg.png" alt="" />
                <img
                  class="code"
                  src="../../assets/images/xz_public.png"
                  alt=""
                />
              </div>
            </li>
            <li>
              <div
                class="code-item code-item4"
                @mouseenter="show = true"
                @mouseleave="show = false"
              >
                <div class="code-img">
                  <img
                    src="../../assets/images/xz_certificate_icon.png"
                    alt=""
                  />
                </div>
                <div
                  class="code-name smallsize-font"
                  :class="isChrome ? 'chrome' : ''"
                >
                  资质证书
                </div>
                <img
                  class="btn"
                  src="../../assets/images/certificate_btn.png"
                  alt=""
                />
              </div>
              <div
                class="certificate"
                v-show="show"
                :style="{ opacity: show ? '1' : '0' }"
              >
                <img src="../../assets/images/xz_certificate2.jpg" alt="" />
                <img src="../../assets/images/xz_certificate1.png" alt="" />
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["seachcon", "catid"],
  data() {
    return {
      login: true,
      common_info: {
        store: {
          search_hot_content: {},
        },
      },
      searchtext: "", //搜索商品
      // carnum: 0, //购物车数量
      isChrome: false,
      show: false, //展示证书
    };
  },
  created() {
    let that = this;
    this.common.loginType(this);
    this.common.getCommonInfo(this);
    // if(!this.login){
    // 	this.cartnumapi();
    // }
    document.onkeydown = function (e) {
      let key = window.event.keyCode;
      if (key === 13) {
        if (that.$refs.searchtext.value) {
          that.searchshop();
        }
      }
    };
    var userAgent = navigator.userAgent;
    console.log(userAgent);
    if (/chrome/i.test(userAgent)) {
      this.isChrome = true;
    }
  },
  mounted() {
    this.searchtext = this.seachcon;
  },
  methods: {
    gosystem() {
      window.location.href = "https://old.xzcare.com/";
    },
    refresh() {
      this.$router.go(0);
    },
    // 购物车数量
    // cartnumapi() {
    // 	if (this.$store.state.user) {
    // 		if (this.$store.state.user.token != "") {
    // 			this.$api.cartnum().then(res => {
    // 				if(res.code == 0){
    // 					this.carnum = res.data
    // 				}
    // 			}).catch(err => {
    // 				console.log(err);
    // 			});
    // 		}
    // 	}
    // },
    // cartgoto() {
    // 	this.$router.push("/cat");
    // },
    seachlist(text) {
      let searconter = this.$refs.searchtext.value;
      searconter = text;
      this.searchshop(searconter);
    },
    // 搜索商品
    searchshop(textcon) {
      let searchname = this.$refs.searchtext.value;
      if (textcon) {
        searchname = textcon;
      }
      if (searchname == "") {
        this.$message({
          showClose: true,
          message: "搜索商品不可为空",
          type: "warning",
          offset: 200,
          duration: 1000,
        });
      } else {
        // let data = {
        //   //埋点
        //   web_url: this.$route.path,
        //   type: 1,
        //   scene: "搜索",
        //   keyword: searchname,
        //   is_keyword: 1,
        // };
        // let params = this.common.publicPage(this, data);
        // console.log(this.common.publicPage(this, data));
        // this.$api.statistics_data(params).then((res) => {
        //   console.log(res);
        // });
        let parms = {
          keyword: searchname,
          search: "search",
        };
        if (this.catid) {
          parms.id = this.catid;
        }
        this.$router.push({
          path: "/list",
          query: parms,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  height: 112px;
  background-color: #fff;
  width: 100%;

  .search-box {
    display: flex;
    height: 112px;
    padding-top: 32px;
    box-sizing: border-box;

    a {
      display: block;
      width: 187px;
      height: 55px;
    }

    .search-img {
      width: auto;
      height: auto;
      object-fit: fill;
      display: block;
      margin: 0 auto;
      max-width: 100%;
      max-height: 100%;
    }

    .search-c {
      margin-left: 113px;

      .search-item {
        display: flex;

        .box {
          width: 548px;
          height: 40px;
          border: 2px solid #ff0008;
          box-sizing: border-box;
          display: flex;
          align-items: center;

          .img {
            height: 16px;
            width: 16px;
            margin-left: 12px;
            margin-right: 4px;
          }

          .search-input {
            width: 100%;
            height: 36px;
            // border: 0 none;
            // box-sizing: border-box;
          }
        }

        .search-btn {
          width: 90px;
          height: 40px;
          background-color: #ff0008;
          color: #fff;
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }

      .search-default {
        display: flex;
        margin-top: 8px;

        li {
          margin-right: 8px;
          color: #b3b3b3;

          span {
            font-size: 12px;
            color: #b3b3b3;
            transition: 0.5s;
            -moz-transition: 0.5s;
            -webkit-transition: 0.5s;
            -o-transition: 0.5s;
            cursor: pointer;

            &:hover {
              color: #ff0e25;
            }
          }
        }
      }
    }

    .cat {
      height: 40px;
      width: 120px;
      border: 1px solid #ff0008;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ff0008;
      box-sizing: border-box;
      margin-left: 32px;
      cursor: pointer;
      border-radius: 2px;
      position: relative;
      a {
        display: inline-block;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ff0008;
      }
      span {
        position: absolute;
        top: 3px;
        left: 23px;
        right: auto;
        display: inline-block;
        padding: 1px 3px;
        font-size: 12px;
        line-height: 12px;
        color: #fff;
        background-color: #e1251b;
        border-radius: 7px;
        min-width: 12px;
        text-align: center;
      }

      .xia {
        height: 18px;
        width: 18px;
        margin-right: 12px;
      }
    }

    .code_wrap {
      width: 214px;
      padding-left: 38px;

      .code {
        display: flex;
        .code-item {
          width: 54px;
          margin-left: 14px;
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;
          position: relative;
          .code-img {
            width: 36px;
            height: 36px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .code-name {
            width: 84px;
            font-size: 12px;
            // -webkit-transform: scale(0.8);
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 13px;
            text-align: center;
            margin-top: 4px;
            margin-bottom: 2px;
          }
          .smallsize-font {
            font-size: 12 * 0.8px;
          }
          .chrome {
            transform: scale(0.8);
          }
          .code-activity {
            width: 54px;
            height: 16px;
          }
          .code_activity3 {
            width: 64px;
            height: 16px;
          }
          .btn {
            width: 46px;
            height: 16px;
          }
          .big-code1,
          .big-code2,
          .big-code3 {
            position: absolute;
            bottom: -138px;
            left: 50%;
            transform: translateX(-50%);
            width: 138px;
            height: 138px;
            z-index: 999999;
            opacity: 0;
            .bg {
              width: 100%;
              height: 100%;
            }
            .code {
              width: 130px;
              height: 130px;
              position: absolute;
              top: 4px;
              left: 4px;
            }
          }
        }
        .certificate {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          // width: 873px;
          // height: 320px;
          width: 50%;
          height: 50%;
          z-index: 999999;
          display: flex;
        }
        .certificate img {
          margin: 0 10px;
        }
        .code-item3 {
          width: 64px;
        }

        .code-item1:hover .big-code1 {
          opacity: 1;
          z-index: 9999999;
        }
        .code-item2:hover .big-code2 {
          opacity: 1;
          z-index: 9999999;
        }
        .code-item3:hover .big-code3 {
          opacity: 1;
          z-index: 9999999;
        }
      }
    }
  }
}
</style>
